/* eslint-disable*/
/**
 * Helper functions
 */

import axios from 'axios';

const DEVICE_URL = {
  HTTPS_RDM_USB_NS: 'https://rdm-usb-ns',
  HTTPS_RDM_USB_NS_LOCAL: 'https://rdm-usb-ns.local',
  HTTPS_USB_RDMSCANNERS_NET: 'https://usb.rdmscanners.net',
  HTTPS_IP: 'https://192.168.253.1',

  HTTP_IP: 'http://192.168.253.1',
  HTTP_IP_8080: 'http://192.168.253.1:8080',
  PROXY_SCANNER: '/scanner'
};


// eslint-disable-next-line max-classes-per-file
function logError(xErr) {
  console.log(xErr);
}

function getISODateString() {
  function pad(num) {
    const norm = Math.floor(Math.abs(num));
    return (norm < 10 ? '0' : '') + norm;
  }

  const now = new Date();
  const tzo = -(now.getTimezoneOffset());
  const dif = tzo >= 0 ? '+' : '-';

  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}T${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}${dif}${pad(tzo / 60)}:${pad(tzo % 60)}`;
}

function trimString(x) {
  return x.replace(/^\s+|\s+$/gm, '');
}

function timedGet(url, options, timeout = 180000) {
  if (!url) {
    throw new Error('Request URL is not defined!');
  }

  options = options || { method: 'get' };
  let params = 'params' in options ? options['params'] : {};
  params = { t: new Date().getTime(), ...params };
  options = { url, params, timeout: timeout, ...options };

  return axios.request(options);
}


function SCIError(message) {
  this.name = 'SCIError';
  this.message = message;
  this.stack = (new Error()).stack;
}
SCIError.prototype = new Error;

function SCIAlreadyClaimedError(message) {
  this.name = 'SCIAlreadyClaimedError';
  this.message = message;
  this.stack = (new Error()).stack;
}
SCIAlreadyClaimedError.prototype = new SCIError;


const SCI_OPTYPES = {
  SINGLE: 1,
  DECISION: 2,
  BATCH: 3,
  ID_CARD: 4,
  MSR: 5,
  PRINT: 6,
  SCANNER_CARE: 8,
};

const SCI_COMPTYPES = {
  ACCEPT: 1,
  REJECT: 2,
  PRINT: 6,
};

/**
 * SCIConnection class
 */
class SCIConnection {
  constructor(url) {
    this.RESP_TYPES = {
      NA: 0, STATE: 1, OPERATION: 2, RESPXML: 3, XML: 4,
    };

    this.mScannerURL = url;
    this.mUserId = null;

    this.postSciRequest = (respType, func, param, xml) => {
      if (!this.mScannerURL) {
        throw new Error('SCIConnection is not initialized!');
      } else if (!this.mUserId) {
        throw new Error('claimScanner has to be invoked first!');
      }

      return new Promise((resolve, reject) => {
        let request = `Function=${func}&UserId=${encodeURIComponent(this.mUserId)}`;

        if (param !== undefined) {
          request = `${request}&Parameter=${encodeURIComponent(param)}`;
        }
        if (xml !== undefined) {
          const xml2 = xml.replace(/[\n\r]+/g, '');
          request = `${request}&Data=${encodeURIComponent(xml2)}`;
        }
        if (func === 'ClaimScanner') {
          request = `${request}&SessionTime=${encodeURIComponent(getISODateString())}`;
        }

        const tmo = setTimeout(() => reject(new Error(`'${func}' failed - Timed out`)), 60000);

        axios.post(`${this.mScannerURL}/SCI/7.0/sci.esp`, request, {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        }).then((response) => {
          if (response.status !== 200) {
            reject(Error(response.status));
          }
          return response.data;
        }).then((text) => {
          clearTimeout(tmo);

          const responseText = trimString(text);
          if (respType === this.RESP_TYPES.STATE) {
            const up = responseText.toUpperCase();
            if (up === 'IDLE' || up === 'BUSY' || up === 'ERROR') {
              resolve(responseText);
            } else {
              reject(new Error(`'${func}' failed - Unknown SCI state ${responseText}`));
            }
          } else if (respType === this.RESP_TYPES.RESPXML) {
            if (responseText.substr(0, 5) === '<?xml') {
              resolve([new window.DOMParser().parseFromString(responseText, 'application/xml'), responseText]);
            } else if (responseText.length === 0 || responseText.toUpperCase() === 'NO DATA') {
              resolve(null);
            } else {
              reject(new Error(`'${func}' failed - Unknown SCI response ${responseText}`));
            }
          } else if (respType === this.RESP_TYPES.XML) {
            if (responseText.substr(0, 5) === '<?xml') {
              resolve([new window.DOMParser().parseFromString(responseText, 'application/xml'), responseText]);
            } else {
              reject(new Error(`'${func}' failed - Unknown XML response ${responseText}`));
            }
          } else if (respType === this.RESP_TYPES.OPERATION) {
            if (responseText !== 'Success') {
              if (func === 'ClaimScanner' && responseText == 'Already Claimed') {
                reject(new SCIAlreadyClaimedError(`'${func}' failed - ${responseText}`));
              } else {
                reject(new Error(`'${func}' failed - ${responseText}`));
              }
            } else {
              resolve(responseText);
            }
          } else {
            resolve(responseText);
          }
        }).catch((error) => {
          clearTimeout(tmo);
          reject(error);
        });
      });
    };
  }

  get scannerURL() {
    return this.mScannerURL;
  }

  claimScanner(userID) {
    if (!userID) {
      throw new Error('Cannot invoke "ClaimScanner" - userId is empty!');
    } else if (this.mUserId && this.mUserId !== userID) {
      throw new Error('Cannot invoke "ClaimScanner" - connection is active!');
    }

    const oldUserId = this.mUserId;
    this.mUserId = userID;
    try {
      return this.postSciRequest(this.RESP_TYPES.OPERATION, 'ClaimScanner').then(
        (ret) => ret
      ).catch((err) => {
        this.mUserId = null;
        return Promise.reject(err);
      });
    } catch (e) {
      this.mUserId = oldUserId;
      throw e;
    }
  }

  releaseScanner(userID = null) {
    const oldUserId = this.mUserId;
    try {
      if (userID) {
        this.mUserId = userID;
      }

      return this.postSciRequest(this.RESP_TYPES.OPERATION, 'ReleaseScanner')
        .then((ret) => {
          this.mUserId = null;
          return ret;
        })
        .catch((err) => {
          // Cleanup NUNCA debe romper la UI, especialmente tras un reboot del escáner
          this.mUserId = null;
          const isNet =
            (err && (err.code === 'ERR_NETWORK' || err.message === 'Network Error'));
          if (isNet) {
            console.warn('[releaseScanner] network error ignored');
            return 'Ignored';
          }
          console.warn('[releaseScanner] non-fatal error ignored:', err?.message || err);
          return 'Ignored';
        });
    } catch (e) {
      this.mUserId = oldUserId;
      throw e;
    }
  }

  getSciVersion() {
    return this.postSciRequest(this.RESP_TYPES.NA, 'GetSciVersion');
  }

  getState() {
    return this.postSciRequest(this.RESP_TYPES.STATE, 'GetState');
  }

  startOperation(startType, xml) {
    if (!startType) {
      throw new Error('Parameter "startType" is missing in startOperation');
    }
    if (!xml) {
      throw new Error('Parameter "xml" is missing in startOperation');
    }
    return this.postSciRequest(this.RESP_TYPES.OPERATION, 'StartOperation', startType, xml);
  }

  completeOperation(completeType, xml) {
    if (!completeType) {
      throw new Error('Parameter "completeType" is missing in CompleteOperation');
    }
    if (completeType === 1 && !xml) {
      throw new Error('Parameter "xml" is missing in CompleteOperation');
    }
    return this.postSciRequest(this.RESP_TYPES.OPERATION, 'CompleteOperation', completeType, xml);
  }

  getOperationXml() {
    // FIX: antes llamaba sin respType y rompía el parser de respuesta
    return this.postSciRequest(this.RESP_TYPES.NA, 'GetOperationXml');
  }

  getResponseXml(wait) {
    return this.postSciRequest(this.RESP_TYPES.RESPXML, 'GetResponseXml', wait);
  }

  getScannerXml() {
    return this.postSciRequest(this.RESP_TYPES.XML, 'GetScannerXml');
  }
}


/**
 * Probing
 * @param {xDevice} device - device serial number or null if probing for USB device
 */
function probeConnection(xDevice = null, xOptions = {}) {
  const doTestSCIConnection = (host, path = `/SCI/7.0/sci.esp?_=${Date.now()}`) => {
    return new Promise((resolve, reject) => {
      const targetURL = host + path;
      const tmo = setTimeout(() => reject(new Error('Timed out!')), xOptions.timeout || 10000);

      axios.post(targetURL, 'Function=GetSciVersion&UserId=Any&Parameter=&Data=', {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      }).then((response) => {
        clearTimeout(tmo);
        if (response.status == 200) {
          resolve(targetURL);
        } else {
          reject(new Error(response.status));
        }
      }).catch((error) => {
        clearTimeout(tmo); // FIX: limpiar timeout también en catch
        reject(error);
      });
    });
  };

  const doTestScannerHostnames = (hostUrls) => {
    // Normaliza: acepta Array, Map, objeto plano o string único
    const list = Array.isArray(hostUrls)
      ? hostUrls
      : (hostUrls instanceof Map
          ? Array.from(hostUrls.values())
          : (hostUrls && typeof hostUrls === 'object'
              ? Object.values(hostUrls)
              : [hostUrls]));
    const targets = (list || []).filter(Boolean);

    return new Promise((resolve, reject) => {
      const PROBE_IN_PROGRESS = 0;
      const PROBE_SUCC = 1;
      const PROBE_FAILED = 2;
      const probeStatusList = new Array(targets.length);

      const wantsConn =
        (xOptions && xOptions.ReturnConnection === true) ||
        (xOptions && typeof xOptions.get === 'function' && xOptions.get('ReturnConnection') === true);

      probeStatusList.fill(PROBE_IN_PROGRESS);
      let isNetworkError = false;

      targets.forEach((hostUrl, idx) => {
        doTestSCIConnection(hostUrl).then(() => {
          probeStatusList[idx] = PROBE_SUCC;

          if (wantsConn) {
            resolve(new SCIConnection(hostUrl));
          } else {
            resolve(hostUrl);
          }
        }).catch((error) => {
          probeStatusList[idx] = PROBE_FAILED;
          console.log(`probeConnection failed -- error ${idx}: ${JSON.stringify(error, null, 2)}`);
          if (!isNetworkError && (
            (error && error.code === 'ERR_NETWORK') ||
            (error && error.message === 'Network Error')
          )) {
            isNetworkError = true;
          }
          const allFailed = probeStatusList.every((x) => (x === PROBE_FAILED));
          if (allFailed) {
            console.log(`isNetworkError=${isNetworkError}`);
            if (isNetworkError) {
              console.log('Network Error');
              reject(new Error('Cannot connect to the Scanner! (Network Error)'));
            } else {
              reject(new Error('Cannot connect to the Scanner!'));
            }
          }
        });
      });
    });
  };

  // En dev: /scanner → evita CORS/TLS; en prod, si 404, cae a IPs locales
  if (!xDevice) {
    return doTestScannerHostnames([
      DEVICE_URL.PROXY_SCANNER,
      DEVICE_URL.HTTPS_IP,
      DEVICE_URL.HTTP_IP,
      DEVICE_URL.HTTP_IP_8080
      // DEVICE_URL.HTTPS_RDM_USB_NS,
      // DEVICE_URL.HTTPS_RDM_USB_NS_LOCAL,
    ]);
  }

  if (xOptions.isDeviceURL) {
    return Promise.resolve(`${xDevice}`);
  } else if (
    /^HTTPS?:\/\/RD[0-9]{13}$/.test(String(xDevice).toUpperCase()) ||
    /^HTTPS:\/\/RD[0-9]{15}$/.test(String(xDevice).toUpperCase()) ||
    /^HTTPS:\/\/USB\.RDMSCANNERS\.NET$/.test(String(xDevice).toUpperCase())
  ) {
    return doTestScannerHostnames([xDevice, `${xDevice}.local`]);
  }

  if (/^[0-9]{13}$/.test(xDevice) || /^[0-9]{15}$/.test(xDevice)) {
    return doTestScannerHostnames([`https://rd${xDevice}`, `https://rd${xDevice}.local`]);
  }

  if (/^RD[0-9]{13}$/.test(String(xDevice).toUpperCase()) || /^RD[0-9]{15}$/.test(String(xDevice).toUpperCase())) {
    return doTestScannerHostnames([`https://${xDevice}`, `https://${xDevice}.local`]);
  }

  return doTestScannerHostnames([`https://${xDevice}`, `https://${xDevice}.local`]);
}

export {
  probeConnection as default,
  SCI_OPTYPES, SCI_COMPTYPES, SCIError, SCIAlreadyClaimedError,
  SCIConnection,
  timedGet, logError,
  DEVICE_URL
};
